import type { ReactNode } from "react";
import React from "react";
import type { IStepsFormProps } from "../../shared/forms/steps/Steps";
import ListNameInput from "./inputs/ListNameInput";
import ListDescriptionInput from "./inputs/ListDescriptionInput";
import ListFileInput from "./inputs/ListFileInput";
import { FormText } from "reactstrap";
import { FormattedMessage } from "react-intl";

export const LIST_NAME = "listName";
export const LIST_DESCRIPTION = "description";
export const LIST_FILE = "file";

export interface IListFormProps extends IStepsFormProps {
  form: string;
  children: ReactNode;
}

export default ({ children }: IListFormProps) => (
  <>
    <ListNameInput inputID={LIST_NAME} />

    <ListDescriptionInput inputID={LIST_DESCRIPTION} />

    <ListFileInput inputID={LIST_FILE} />
    <p>
      <FormText color="muted">
        <a href="/downloads/raange-sample-import.csv">
          <FormattedMessage id="lists.list_file.sample" />
        </a>
      </FormText>
    </p>

    {children}
  </>
);
